
export default {
	props: {
		list: {
			type: Array,
			default: () => []
		},
		isBuyer: {
			type: Boolean,
			default: true
		},
		bargainInfo: {
			type: Object,
			default: () => ({ status: null, bargainOrderPayStatus: null })
		}
	},
	computed: {
		buyerText() {
			return this.isBuyer ? '我的报价' : '买家报价'
		},
		sellerText() {
			return this.isBuyer ? '卖家还价' : '我的还价'
		}
	}
}
